export var EventStatus;
(function (EventStatus) {
    EventStatus["DRAFT"] = "DRAFT";
    EventStatus["PLANNING"] = "PLANNING";
    EventStatus["CONFIRMED"] = "CONFIRMED";
    EventStatus["IN_PROGRESS"] = "IN_PROGRESS";
    EventStatus["COMPLETED"] = "COMPLETED";
    EventStatus["CANCELLED"] = "CANCELLED";
})(EventStatus || (EventStatus = {}));
export var ClientRole;
(function (ClientRole) {
    ClientRole["BRIDE"] = "BRIDE";
    ClientRole["GROOM"] = "GROOM";
    ClientRole["PARENT_OF_BRIDE"] = "PARENT_OF_BRIDE";
    ClientRole["PARENT_OF_GROOM"] = "PARENT_OF_GROOM";
    ClientRole["OTHER_FAMILY"] = "OTHER_FAMILY";
    ClientRole["BAR_BAT_MITZVAH"] = "BAR_BAT_MITZVAH";
    ClientRole["HOST"] = "HOST";
    ClientRole["OTHER"] = "OTHER";
})(ClientRole || (ClientRole = {}));
export var TagType;
(function (TagType) {
    TagType["TEXT"] = "TEXT";
    TagType["DATE"] = "DATE";
    TagType["NUMBER"] = "NUMBER";
})(TagType || (TagType = {}));
//# sourceMappingURL=event.js.map